import React from 'react'

const BazaarvoiceRatingSummary = ({ productId }) => {
  return (
    <div className='mxd-rating'>
      <div data-bv-show='rating_summary' data-bv-product-id={productId}></div>
    </div>
  )
}
export default React.memo(BazaarvoiceRatingSummary)
